import React, { useState } from 'react';
import {
  Box, Card, CardContent, TextField, Button, Typography,
  CircularProgress, Alert,
} from '@mui/material';
import appConfig from '../../../utils/appConfig';
import { useAdmin } from '../../../AdminContext';

const AdminLoginForm: React.FC = () => {
  const { login } = useAdmin();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleLogin = async () => {
    if (!username || !password) return;
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(`${appConfig.apiUrls.baseUrl}/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });
      const data = await res.json();
      if (data.success) {
        login(data.token, data.role, data.username);
        // AdminPage will re-render and show AdminDashboard automatically
      } else {
        setError(data.error || 'שם משתמש או סיסמה שגויים');
      }
    } catch {
      setError('שגיאת תקשורת עם השרת');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      bgcolor="#f5f5f5"
      dir="rtl"
    >
      <Card sx={{ width: 380, p: 2, boxShadow: 4 }}>
        <CardContent>
          <Typography variant="h5" align="center" gutterBottom fontWeight="bold">
            מערכת ניהול הסעות
          </Typography>
          <Typography variant="body2" align="center" color="text.secondary" mb={3}>
            כניסה לממשק הניהול
          </Typography>

          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

          <TextField
            fullWidth
            label="שם משתמש"
            variant="outlined"
            margin="normal"
            value={username}
            onChange={e => setUsername(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && handleLogin()}
            inputProps={{ style: { textAlign: 'right' } }}
          />
          <TextField
            fullWidth
            label="סיסמה"
            type="password"
            variant="outlined"
            margin="normal"
            value={password}
            onChange={e => setPassword(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && handleLogin()}
            inputProps={{ style: { textAlign: 'right' } }}
          />
          <Button
            fullWidth
            variant="contained"
            size="large"
            onClick={handleLogin}
            disabled={loading || !username || !password}
            sx={{ mt: 2 }}
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : 'כניסה'}
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default AdminLoginForm;
